import Vue from 'vue';
import Vuelidate from 'vuelidate';
import vSelect from 'vue-select';
import VCalendar from 'v-calendar';
import vuelidateErrorExtractor from 'vuelidate-error-extractor';
import VueMq from 'vue-mq';
import LocalStorage from 'vue-ls';
import Switches from 'vue-switches';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import boost from 'highcharts/modules/boost';
import PortalVue from 'portal-vue';

// bootstrap-vue components
import bContainer from 'bootstrap-vue/es/components/layout/container';
import bRow from 'bootstrap-vue/es/components/layout/row';
import bCard from 'bootstrap-vue/es/components/card/card';
import bCol from 'bootstrap-vue/es/components/layout/col';
import bForm from 'bootstrap-vue/es/components/form/form';
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group';
import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
import bFormFile from 'bootstrap-vue/es/components/form-file/form-file';
import bFormCheckbox from 'bootstrap-vue/es/components/form-checkbox/form-checkbox';
import bFormCheckboxGroup from 'bootstrap-vue/es/components/form-checkbox/form-checkbox-group';
import bFormRadio from 'bootstrap-vue/es/components/form-radio/form-radio';
import bFormRadioGroup from 'bootstrap-vue/es/components/form-radio/form-radio-group';
import bButton from 'bootstrap-vue/es/components/button/button';
import bImg from 'bootstrap-vue/es/components/image/img';
import bAlert from 'bootstrap-vue/es/components/alert/alert';
import bDropdown from 'bootstrap-vue/es/components/dropdown/dropdown';
import bDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item';
import bModal from 'bootstrap-vue/es/components/modal/modal';
import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
import bTab from 'bootstrap-vue/es/components/tabs/tab';
import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
import bTable from 'bootstrap-vue/es/components/table/table';
import 'bootstrap-vue/es/components/table/table.css';
import vBPopover from 'bootstrap-vue/es/directives/popover/popover';
import vBTooltip from 'bootstrap-vue/es/directives/tooltip/tooltip';
import bCollapse from 'bootstrap-vue/es/components/collapse/collapse';

import './assets/styles/main.scss';

import App from './app';
import store from './store';
import router from './router';
import { HTTP } from './resources/base';
import AddAuthorizationHeaderInterceptor from './resources/interceptors/add-authorization-header';
import RefreshTokenInterceptor from './resources/interceptors/refresh-token';
import ValidationMessage from './components/shared/validation-message';
import FormFieldTemplate from './components/shared/form-field-template';
import Loader from './components/shared/loader';
import Icon from './components/shared/icon';

Vue.config.productionTip = false;
Vue.use(Vuelidate);

Vue.use(VCalendar, {
  firstDayOfWeek: 2,
  masks: {
    weekdays: 'WWW'
  }
});

Vue.use(vuelidateErrorExtractor, {
  template: FormFieldTemplate,
  messages: {
    required: 'The {attribute} field is required',
    privilegesScope: 'Must start and end with "/". Must include project code, e.q. "/natu/#/".',
    phoneNumber:
      'Invalid phone number format. Please input international code. Do not use any spaces, e.g. +441234567890',
    email: 'E-mail must be valid'
  }
});
Vue.use(HighchartsVue);
boost(Highcharts);

Vue.use(PortalVue);

Vue.use(VueMq, {
  breakpoints: {
    sm: 767,
    md: 991,
    lg: 1199,
    xl: Infinity
  }
});

Vue.use(LocalStorage, {
  namespace: 'lv_',
  name: 'localStorage',
  storage: 'local'
});

Vue.directive('b-popover', vBPopover);
Vue.directive('b-tooltip', vBTooltip);

const bootstrapComponents = {
  'b-row': bRow,
  'b-container': bContainer,
  'b-col': bCol,
  'b-card': bCard,
  'b-form': bForm,
  'b-form-file': bFormFile,
  'b-form-group': bFormGroup,
  'b-form-input': bFormInput,
  'b-form-checkbox': bFormCheckbox,
  'b-form-checkbox-group': bFormCheckboxGroup,
  'b-form-select': bFormSelect,
  'b-form-radio-group': bFormRadioGroup,
  'b-form-radio': bFormRadio,
  'b-button': bButton,
  'b-img': bImg,
  'b-alert': bAlert,
  'b-dropdown': bDropdown,
  'b-dropdown-item': bDropdownItem,
  'b-modal': bModal,
  'b-pagination': bPagination,
  'b-tab': bTab,
  'b-tabs': bTabs,
  'b-table': bTable,
  'b-collapse': bCollapse
};

Object.keys(bootstrapComponents).forEach(key => Vue.component(key, bootstrapComponents[key]));

HTTP.interceptors.push(AddAuthorizationHeaderInterceptor(store));
HTTP.interceptors.push(RefreshTokenInterceptor(HTTP, router, store));

Vue.component('ValidationMessage', ValidationMessage);
Vue.component('v-select', vSelect);
Vue.component('Loader', Loader);
Vue.component('Icon', Icon);
Vue.component('Switches', Switches);

new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  mounted() {
    if (Vue.localStorage.get('darkMode', 'notSet') === 'notSet') {
      Vue.localStorage.set('darkMode', false);
    }
    this.$store.commit('toggleDarkMode', Vue.localStorage.get('darkMode'));
  },
  render(h) {
    return h('App');
  }
});
